(function () {
  function productRoot() {
    return document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('main product-info');
  }

  function movePurchaseDetails() {
    var root = productRoot();
    if (!root) return;

    var buyButtons = root.querySelector('product-form.product-form');
    var installmentForm = root.querySelector('form.installment');
    var paymentOptions = installmentForm && installmentForm.parentElement;
    var instagram = root.querySelector('.sfg-instagram-username');

    if (paymentOptions) {
      paymentOptions.classList.add('sfg-listing-payment-options');

      if (!paymentOptions.querySelector('.sfg-listing-payment-options__title')) {
        var title = document.createElement('p');
        title.className = 'sfg-listing-payment-options__title';
        title.textContent = 'Flexible payment options';
        paymentOptions.prepend(title);
      }
    }

    if (buyButtons && paymentOptions && buyButtons.nextElementSibling !== paymentOptions) {
      buyButtons.insertAdjacentElement('afterend', paymentOptions);
    }

    if (instagram) {
      instagram.setAttribute('data-sfg-listing-instagram', '');
      var titleLabel = instagram.querySelector('.sfg-instagram-username__title');
      var help = instagram.querySelector('.sfg-instagram-username__help');

      if (titleLabel) titleLabel.textContent = 'Instagram handle';
      if (help) {
        help.textContent =
          'Optional — add this only if you would like us to connect your order with your Instagram account.';
      }

      var insertionPoint = paymentOptions || buyButtons;
      if (insertionPoint && insertionPoint.nextElementSibling !== instagram) {
        insertionPoint.insertAdjacentElement('afterend', instagram);
      }
    }
  }

  function tidyEmptyReviews() {
    document.querySelectorAll('#judgeme_product_reviews').forEach(function (widget) {
      var hasUsefulEmptyState = !!widget.querySelector('.jm-no-reviews-state');
      var renderedReviews = widget.querySelectorAll('.jdgm-rev').length;
      widget.classList.toggle('sfg-listing-zero-reviews', hasUsefulEmptyState && renderedReviews === 0);
    });
  }

  function hideBrokenPriceDropPrompt() {
    var priceDrop = document.getElementById('spm_subscribe_price_drop_alert');
    if (!priceDrop) return;

    var text = (priceDrop.textContent || '').replace(/\s+/g, ' ').trim();
    var isBroken = text === '' || /undefined/i.test(text);
    priceDrop.classList.toggle('sfg-listing-broken-widget', isBroken);

    if (isBroken) {
      priceDrop.setAttribute('aria-hidden', 'true');
      priceDrop.hidden = true;
    }
  }

  function updateChatOffset() {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;

    var sticky = document.querySelector('[id^="SfgLuxurySticky-"]');
    var stickyVisible =
      sticky && !sticky.classList.contains('is-stopped') && sticky.getAttribute('aria-hidden') !== 'true';
    var offset = 20;

    if (stickyVisible) {
      offset = Math.ceil(sticky.getBoundingClientRect().height) + 18;
    }

    chat.style.setProperty('--shopify-agent-activator-offset', offset + 'px');
  }

  function bindStickyObserver() {
    var sticky = document.querySelector('[id^="SfgLuxurySticky-"]');
    if (!sticky || sticky.dataset.sfgListingChatBound === 'true') return;

    sticky.dataset.sfgListingChatBound = 'true';
    new MutationObserver(updateChatOffset).observe(sticky, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  }

  function applyListingLayout() {
    if (!productRoot()) return;
    movePurchaseDetails();
    tidyEmptyReviews();
    hideBrokenPriceDropPrompt();
    bindStickyObserver();
    updateChatOffset();
  }

  var refreshQueued = false;

  function queueListingLayout() {
    if (refreshQueued) return;
    refreshQueued = true;

    window.requestAnimationFrame(function () {
      refreshQueued = false;
      applyListingLayout();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueListingLayout, { once: true });
  } else {
    queueListingLayout();
  }

  document.addEventListener('shopify:section:load', queueListingLayout);
  window.addEventListener('resize', updateChatOffset);
  window.addEventListener('scroll', updateChatOffset, { passive: true });

  var observer = new MutationObserver(queueListingLayout);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(queueListingLayout, 300);
  window.setTimeout(queueListingLayout, 1000);
  window.setTimeout(queueListingLayout, 2500);
})();
